/**
 * Helper used to manage customer-specific configurations.
 * The customer is determined by the domain of the application.
 * If the specified customer configuration is not found, it falls back to the default 'air' configuration.
 */

let customerConfig;

/**
 * Obtains the name of the current customer
 * @returns {string} Customer name
 */
export const getCustomerName = () => {
  const domain = window.location.hostname;
  if (domain.includes('rattix')) { return 'rattix' };
  if (domain.includes('air')) { return 'air' };

  return 'air'; // Default to AIR if no specific customer is detected
}

try {
  const customer = getCustomerName();
  // Synchronous import of the customer configuration based on the environment variable
  customerConfig = require(`../domains/${customer}/customerConfig.js`).default;
} catch (error) {
  // Fallback on AIR
  console.warn(`Configuration not found, using AIR as default`, error);
  customerConfig = require(`../domains/air/customerConfig.js`).default;
}

/**
 * Obtains the configuration for the current customer
 * @returns {Object} Customer configuration
 */
export const getCustomerConfig = () => customerConfig;
